import React, { useEffect } from "react";
import Lookup from "../images/gas-lookup.jpg";
import RsMerkle from "../images/rsmerkle.jpg";
import extLink from "../icons/extLink.png";
import Aos from "aos";
import "aos/dist/aos.css";

const Packages = () => {
  const PackageDescs = [
    {
      id: 1,
      name:"rs-merkletree",
      desc:"A Rust Library to generate Merkle Trees.",
      src: RsMerkle,
      style: "",
      link: "https://crates.io/crates/rs-merkletree",
    },
    {
      id: 2,
      name:"Gas Lookup",
      desc:" CLI tool to calculate the total amount of Ether spent on gas on transacting on the Ethereum blockchain withing a given date frame",
      src: Lookup,
      style: "",
      link: "https://crates.io/crates/gas-lookup",
    },
  ];

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div className="overflow-hidden my-20">
      <div name="package" className="text-white h-100vh ">
        <div className="max-w-7xl h-full mx-auto flex flex-col justify-center items-center">
          <div data-aos="slide-up" className="py-8">
            <h1 className=" font-rubik font-normal text-3xl md:text-6xl text-center text-white border-b-2 border-[#b03016] mx-16 pb-2 mb-4">
              Published{" "}
              <span className="text-[#30BCED] font-medium"> Packages</span>
            </h1>
          </div>

          <div
            data-aos="fade-left"
            className="overflow-hidden flex flex-wrap gap-x-6 md:gap-x-16 gap-y-10 md:gap-y-12 text-center place-items-center  mb-12 pb-6 px-4 md:px-0"
          >
            {PackageDescs.map(({ id, src, style, link,name,desc }) => (
              <div
                className={
                  "key={id} text-gray-700  rounded-lg mx-auto " + style
                }
              >
                <div className=" shadow-lg shadow-black h-full pb-6 w-64 text-[#F7F0F5] flex flex-col flex-wrap ">
                  <img className=" rounded-lg w-80" src={src} alt="/" />
                  <a href={link} target="_blank" rel="noreferrer" className="">
                    <img
                      className="relative w-12 bottom-4 bg-white left-[43%] rounded-full hover:scale-105"
                      src={extLink}
                      alt=""
                    />
                  </a>
                  <p className="text-4xl py-4 font-rubik">{name}</p>
                  <p>
                   {desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Packages;
